import { queryOptions, useQueries } from "@tanstack/react-query";

import { coachingQueriesStore } from "@/features/coaching/api";
import { getSessionsRefetchInterval } from "@/features/coaching/utils";
import { consultationsQueriesStore } from "@/features/consultations/api";

export const useUpcomingEvents = () => {
  return useQueries({
    queries: [
      consultationsQueriesStore.consultations.appointments._ctx.list._ctx
        .upcoming._ctx.journeySupport,
      consultationsQueriesStore.consultations.appointments._ctx.list._ctx
        .upcoming._ctx.dietitian,
      queryOptions({
        ...coachingQueriesStore.coaching.patient._ctx.session._ctx.upcoming,
        refetchInterval: ({ state: { data } }) =>
          getSessionsRefetchInterval(data),
      }),
    ],
    combine: (results) => ({
      data: results
        .map((result) => result.data)
        .flat()
        .filter((event) => !!event)
        .sort((a, b) => {
          const aTime =
            "startTime" in a
              ? new Date(a.startTime).getTime()
              : new Date(a.startAt).getTime();
          const bTime =
            "startTime" in b
              ? new Date(b.startTime).getTime()
              : new Date(b.startAt).getTime();
          return aTime - bTime;
        }),
      isLoading: results.some((result) => result.isLoading),
      isError: results.some((result) => result.isError),
      isSuccess: results.every((result) => result.isSuccess),
    }),
  });
};
